import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useProfilePicture } from "@miplatform/hooks";
import { externalReferenceId } from "@miplatform/utils";

export const useAccountSummaryTabViewModel = ({
  stateManager,
  accountDetail,
  setAccountDetail,
  getAccountDetails,
  setOpenConfirmModal,
}) => {
  const { fileName, profilePicture, isLoading, removePicture, uploadPicture } =
    useProfilePicture({
      values: accountDetail,
      getExternalReferenceId: () =>
        externalReferenceId.getAccountRefId({
          accountId: accountDetail?.id,
        }),
    });

  const handleUploadProfilePicture = async (file) => {
    const response = await uploadPicture(file);
    if (response.status === HTTP_STATUSES.OK) {
      getAccountDetails(accountDetail?.id);
    }
  };

  const handleRemoveProfilePicture = async () => {
    const response = await removePicture();
    if (response.status === HTTP_STATUSES.OK) {
      setAccountDetail({
        ...accountDetail,
        documents: accountDetail?.documents.filter(
          (d) => d.metadata_Title !== fileName
        ),
      });

      return true;
    }

    return false;
  };

  const handleProfilePictureChange = async (file) => {
    if (!file) {
      return null;
    }
    if (!profilePicture) {
      return handleUploadProfilePicture(file);
    }
    const isDeleted = await handleRemoveProfilePicture();
    if (isDeleted) {
      return handleUploadProfilePicture(file);
    }
    return null;
  };

  const handleUpdateAccount = (data) => {
    stateManager.run(async () => {
      const response = await accountService.accounts.updateAccount({
        id: accountDetail.id,
        data,
        modifiedOn: accountDetail.modifiedOn,
        toastMessageConfig: {
          success: { text: `Customer ${data.name} updated successfully.` },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        getAccountDetails(accountDetail?.id);
        setOpenConfirmModal(false);
      }
    });
  };

  return {
    profilePicture,
    handleProfilePictureChange,
    handleRemoveProfilePicture,
    isLoading: stateManager.isBusy() || isLoading,
    handleUpdateAccount,
  };
};
